import {
  ClientEventBatchRequest,
  DeviceType,
  EventContext,
  EventLogger,
  EventId,
} from '@kouzoh/client-event-logger';
import { isAndroid, isIOS } from '@/utils/userAgent';
import { getOrSetUUID } from './uuid';

export const eventContext = (): Partial<EventContext> => {
  const deviceType = isAndroid()
    ? DeviceType.DEVICE_ANDROID
    : isIOS()
      ? DeviceType.DEVICE_IOS
      : DeviceType.DEVICE_WEB;

  return {
    version: process.env.NEXT_PUBLIC_VERSION,
    webProperty: 'worker_web',
    uuid: getOrSetUUID(),
    deviceType: deviceType,
  };
};

function prettyPrintEvent(req: ClientEventBatchRequest) {
  const events = req.events?.map((e) => e.protoEvent);
  const shouldLog = process.env.NEXT_PUBLIC_APP_ENV !== 'prod';
  if (shouldLog && events) {
    console.group('%cV2 Laplace Event Batch', 'color: DodgerBlue');
    // print each event
    events.forEach((e) => {
      const typeName = e?.type ? EventId[e.type] : 'Unknown Event Type';
      console.groupCollapsed(typeName);
      console.log(e);
      console.groupEnd();
    });

    // print whole batch request
    console.groupCollapsed('ClientEventBatchRequest');
    console.log(req);
    console.groupEnd();
    console.groupEnd();
  }
}

export const makeEventLogger = () =>
  new EventLogger({
    batchInterval: 1000,
    realTimeInterval: 1000,
    batchMaxSize: process.env.NEXT_PUBLIC_APP_ENV === 'dev' ? 1 : undefined, // defer to defaults
    eventContext,
    endpointDomain: process.env.NEXT_PUBLIC_LAPLACE_API_URL ?? '',
    onFlush: ({ payload }) => prettyPrintEvent(payload),
  });
